import { useMemo } from "react";
import { useSessionContext } from "@/components/AuthModule/SessionContext";
import { completeYourTripBanners, matchEligibility } from "@/utils/banners";

export const useCompleteYourTripBanners = () => {
  const { sessionInfo } = useSessionContext();

  return useMemo(() => {
    const banners = completeYourTripBanners;
    return banners.filter((banner) => {
      return matchEligibility(
        sessionInfo?.userDetails,
        banner.eligibilityPayloadMapping
      );
    });
  }, [sessionInfo?.userDetails]);
};
